import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

interface User {
  uid: string;
  email?: string;
  displayName?: string;
  credits?: number;
}

@Component({
  selector: 'app-adminnav',
  templateUrl: './adminnav.component.html',
  styleUrls: ['./adminnav.component.scss']
})
export class AdminnavComponent implements OnInit {
  users$: Observable<User[]>;
  currentUser$: Observable<User | null>;

  constructor(private afs: AngularFirestore, private afAuth: AngularFireAuth) { }

  ngOnInit(): void {
    this.currentUser$ = this.afAuth.authState.pipe(
      switchMap(user => {
        if (user) {
          return this.afs.doc<User>(`users/${user.uid}`).valueChanges();
        } else {
          return of(null);
        }
      })
    );

    // TODO: Add admin role check before fetching all users
    // For now, directly fetching users. In a real app, secure this.
    this.users$ = this.afs.collection<User>('users').valueChanges({ idField: 'uid' });
  }

  updateCredits(user: User, newCredits: string): void {
    const credits = parseInt(newCredits, 10);
    if (user && user.uid && !isNaN(credits)) {
      this.afs.doc(`users/${user.uid}`).update({ credits: credits })
        .then(() => console.log(`Credits updated for ${user.email || user.uid}`))
        .catch(err => console.error(`Error updating credits for ${user.email || user.uid}`, err));
    } else {
      console.error('Invalid user or credits value');
    }
  }

  async grantDefaultCredits(user: User): Promise<void> {
    if (user && user.uid) {
      const userRef: AngularFirestoreDocument<User> = this.afs.doc(`users/${user.uid}`);
      const userSnap = await userRef.get().toPromise();
      if (userSnap.exists) {
        const userData = userSnap.data();
        if (userData.credits === undefined || userData.credits === null) {
          await userRef.update({ credits: 100 });
          console.log(`Granted default 100 credits to ${user.email || user.uid}`);
        } else {
          console.log(`User ${user.email || user.uid} already has credits set.`);
        }
      }
    }
  }
}
